import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams((location.hash || "").replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    googleSession(sessionId)
      .then((user) => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user } });
      })
      .catch(() => {
        toast.error("Google sign-in didn't complete — please try again");
        navigate("/auth", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="grid min-h-[60vh] place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-royal" />
        <p className="mt-3 text-sm font-medium text-slate-500">Signing you in with Google…</p>
      </div>
    </main>
  );
}
